import React from 'react';
import { Icon } from './Icon.js';
export const IconChartMsg = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M2 11.5C2 16.7467 6.25329 21 11.5 21H21V11.5C21 6.25329 16.7467 2 11.5 2C6.25329 2 2 6.25329 2 11.5Z", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M6.5 13.5L10 10L11.5 11.5L13 13L16.5 9.5", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconChartMsg.js.map